import React, { useRef, useState } from "react";

export default function SwipeRow({
  children,
  onDelete,
  deleteLabel = "Delete",
  className = "",
}: {
  children: React.ReactNode;
  onDelete: () => void;
  deleteLabel?: string;
  className?: string;
}) {
  const startX = useRef<number | null>(null);
  const [dx, setDx] = useState(0);
  const [open, setOpen] = useState(false);
  const MAX = 92; // px reveal
  const THRESH = 56;

  function onTouchStart(e: React.TouchEvent) {
    startX.current = e.touches[0].clientX;
  }
  function onTouchMove(e: React.TouchEvent) {
    if (startX.current == null) return;
    const cur = e.touches[0].clientX;
    const delta = Math.min(0, Math.max(-MAX, cur - startX.current));
    setDx(open ? Math.min(0, delta - MAX) : delta);
  }
  function onTouchEnd() {
    const snapOpen = Math.abs(dx) > THRESH;
    setOpen(snapOpen);
    setDx(0);
  }

  return (
    <div className={`relative select-none ${className}`}>
      {/* Desktop delete (visible md+, hidden on mobile) */}
      <div className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-10">
        <button
          type="button"
          className="rounded border border-red-700 bg-red-600/80 px-3 py-1.5 text-white hover:bg-red-600"
          onClick={onDelete}
        >
          {deleteLabel}
        </button>
      </div>

      {/* Mobile swipe layer (md- only) */}
      <div className="md:hidden absolute inset-y-0 right-0 w-[92px] grid place-items-center">
        <button
          type="button"
          className="rounded-md bg-red-600 px-3 py-2 text-white shadow"
          onClick={onDelete}
          aria-label={deleteLabel}
        >
          {deleteLabel}
        </button>
      </div>

      {/* Content; swipable on mobile, static on desktop */}
      <div
        className="relative md:pr-[110px]"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div
          className="transition-transform md:transition-none"
          style={{
            transform:
              // mobile: translate to reveal; desktop: keep at 0
              `translateX(${typeof window !== "undefined" && window.matchMedia && window.matchMedia("(min-width: 768px)").matches ? 0 : open ? -MAX : dx}px)`,
          }}
          onClick={() => {
            // tap to close if open
            if (open) {
              setOpen(false);
            }
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
